export default __webpack_public_path__ + "static/media/old_gold_card.ce25a9a6.png";